import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';

export default function Blog() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 md:px-6 max-w-3xl py-12">
        <button onClick={() => navigate(-1)} className="mb-8 text-sm text-gray-500 hover:text-[#134168] transition-colors">{t('legal.back')}</button>
        <h1 className="text-4xl font-heading font-bold text-[#134168] mb-2">{t('legal.blogTitle')}</h1>
        <p className="text-sm text-gray-400 mb-8">{t('legal.blog.subtitle')}</p>

        <div className="bg-white rounded-3xl p-12 shadow-sm text-center">
          <div className="text-6xl mb-4">📝</div>
          <h2 className="text-2xl font-bold text-[#134168] mb-3">{t('legal.blog.comingSoon')}</h2>
          <p className="text-gray-600 max-w-md mx-auto mb-6">
            {t('legal.blog.preparingContent')}
          </p>
          <button
            onClick={() => navigate('/')}
            className="bg-[#134168] text-white px-6 py-3 rounded-full font-bold hover:bg-[#39b4aa] transition-colors"
          >
            {t('legal.blog.backHome')}
          </button>
        </div>
      </div>
    </div>
  );
}
